/* eslint-disable prefer-destructuring */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import WheelSelector from '../../components/Controller/WheelSelector';
import ActionPanel from '../../components/Controller/ActionPanel';
import Text from './Helmet/Text';
import BaseColor from './Helmet/BaseColor';
import Decal from './Helmet/Decal';
import FabricColor from './Helmet/FabricColor';
import Finish from './Helmet/Finish';
import Goggle from './Helmet/Goggle';
import VisorColor from './Helmet/VisorColor';
import Visor from './Helmet/Visor';
import FrontPrint from './TShirt/FrontPrint';
import FrontBadge from './TShirt/Badge';
import FrontBikeArt from './TShirt/FrontBikeArt';
import BackText from './TShirt/BackText';
import WinterProtection from './Jackets/WinterProtection';
import Armour from './Jackets/Armour';

import { alertWrapper } from '../../utils/alertWrapper';
import Tabs from '../../components/common/Tabs';
import { availableHotspots } from '../../utils/tshirtHotspots';

const categoryComponents = {
  decal: Decal,
  text: Text,
  baseColor: BaseColor,
  baseShirtColor: BaseColor,
  jacketColour: BaseColor,
  rainProtection: BaseColor,
  winterColor: BaseColor,
  internalFabricColor: FabricColor,
  visor: Visor,
  visorColor: VisorColor,
  peakColor: VisorColor,
  finish: Finish,
  goggle: Goggle,
  frontPrint: FrontPrint,
  frontBadge: FrontBadge,
  bikeArt: FrontBikeArt,
  sleeve: FrontBadge,
  backText: BackText,
  winterProtection: WinterProtection,
  backArmour: Armour,
  chestArmour: Armour,
  elbowShouldArmour: Armour
};

const notAllowed = [
  // 'DCL032',
  // 'DCL033',
  // 'DCL034',
  // 'DCL035',
  // 'DCL036',
  // 'DCL037',
  // 'DCL038',
  // 'DCL039',
  // 'DCL040',
  // 'DCL041'
];

const Controller = ({
  allAvailableCustomizations,
  availableCustomizations,
  allCategories,
  availableColors,
  selectedCategory,
  partsConfig,
  availableCategories,
  setSelectedCategory,
  updatePartsConfig,
  removePartConfig,
  setCurrentText,
  setIsConfigSaved,
  currentText,
  setIsLoading,
  activeHotspot,
  setHotspot,
  setBackBikeNumberPlate,
  setFrontBikeNumberPlate,
  tShirtBikeFrontNumberPlate,
  tShirtBikeBackNumberPlate,
  setBackBikeText,
  setFrontBikeText,
  tShirtBikeFrontText,
  tShirtBikeBackText,
  currentActiveParent,
  setCurrentActiveParent,
  openAlertDialog,
  reapplyCustomization,
  setShouldReapplyCustomization,
  selectedVariant
}) => {
  const [openActionPanel, setOpenActionPanel] = useState(true);
  const [selectedTab, setSelectedTab] = useState('');
  const [availableTabs, setAvailableTabs] = useState([]);
  const [categoryData, setCategoryData] = useState([]);

  const options = availableCustomizations;

  const [
    initialSelectedCustomizationIndex,
    setInitialSelectedCustomizationIndex
  ] = useState(null);

  const currentCategory = allCategories.filter(
    cat => cat.name === selectedCategory
  )[0];

  let selectedBaseColorPartId;
  let selectedColorCustomization;
  if (
    availableCategories.map(category => category.name).includes('baseColor')
  ) {
    selectedBaseColorPartId = Object.keys(partsConfig.baseColor).find(
      key => partsConfig.baseColor[key] === true
    );

    selectedColorCustomization = availableColors.filter(
      color => color.partId === selectedBaseColorPartId
    )[0];
  }

  let selectedVisorPartId;
  if (availableCategories.map(category => category.name).includes('visor')) {
    selectedVisorPartId = Object.keys(partsConfig.visor).find(
      key => partsConfig.visor[key] === true
    );
  }

  const [keyboardOpen, setKeyboardOpen] = useState(false);

  useEffect(() => {
    const initialHeight = window.innerHeight;
    window.addEventListener('resize', () => {
      if (window.innerHeight < initialHeight) setKeyboardOpen(true);
      else setKeyboardOpen(false);
    });
  }, []);

  let selectedDecalPartId;
  if (availableCategories.map(category => category.name).includes('decal')) {
    selectedDecalPartId =
      selectedColorCustomization.customizationType === 'flakes'
        ? selectedVariant === 'HelmetOpenFace'
          ? 'DCL010'
          : 'DCL011'
        : Object.keys(partsConfig.decal).find(
            key => partsConfig.decal[key] === true
          );
  }

  const regex = /BCL\d{3}/i;

  const getFilteredData = data => {
    if (data) {
      if (selectedCategory !== 'decal') {
        let filteredData = data;

        if (selectedCategory === 'visorColor') {
          // handle dependency on visorType
          filteredData = data.filter(entry =>
            entry.dependencies.parts.includes(selectedVisorPartId)
          );
        } else if (selectedCategory === 'text') {
          // handle secondary dependencies
          if (selectedDecalPartId) {
            const dataWhiteList =
              selectedColorCustomization.secondaryDependencies[
                selectedDecalPartId
              ];
            filteredData = data.filter(entry =>
              dataWhiteList.includes(entry.partId)
            );
          } else {
            filteredData = data.filter(entry =>
              ['TXT001', 'TXT002'].includes(entry.partId)
            );
          }
        } else if (selectedCategory === 'finish') {
          if (selectedDecalPartId) {
            const selectedDecal = allAvailableCustomizations.decal.find(
              x => x.partId === selectedDecalPartId
            );
            const decalCollisions = selectedDecal.collisions.parts;

            filteredData = data.filter(entry => {
              if (entry.dependencies.parts.some(part => part.match(regex))) {
                if (
                  entry.dependencies.parts.includes(selectedBaseColorPartId) &&
                  !entry.collisions.parts.includes(selectedDecalPartId)
                ) {
                  return true;
                }
                return false;
              }
              if (selectedCategory === 'baseColor') {
                if (!notAllowed.includes(entry.partId)) {
                  return true;
                }
                return false;
              }
              return true;
            });
          } else {
            filteredData = data.filter(entry =>
              ['FSH002'].includes(entry.partId)
            );
          }
        } else {
          filteredData = data.filter(entry => {
            if (entry.dependencies.parts.some(part => part.match(regex))) {
              if (entry.dependencies.parts.includes(selectedBaseColorPartId)) {
                return true;
              }
              return false;
            }
            if (selectedCategory === 'baseColor') {
              if (!notAllowed.includes(entry.partId)) {
                return true;
              }
              return false;
            }
            return true;
          });
        }

        return filteredData;
      }
      return data.filter(
        entry =>
          !notAllowed.includes(entry.partId) ||
          (entry.dependencies.parts.includes(selectedBaseColorPartId) &&
            !entry.collisions.parts.includes(selectedVisorPartId))
      );
    }
  };

  const getFilteredDataForInterCategoryDependency = data => {
    if (selectedCategory === 'bikeArt') {
      const angles = data
        .filter(cust => cust.customizationType === 'angle')
        .map(entry => entry.partId);

      const viewCode = currentActiveParent === 'front' ? 'F' : 'B';

      const selectedAngle = Object.keys(partsConfig.bikeArt).find(key => {
        return (
          angles.includes(key) &&
          key[key.length - 1] === viewCode &&
          partsConfig.bikeArt[key] === true
        );
      });

      const selectedAngleCust = data.filter(
        part => part.partId === selectedAngle
      )[0];

      const models = data
        .filter(cust => cust.customizationType === 'model')
        .map(entry => entry.partId);

      let selectedModel =
        Object.keys(partsConfig.bikeArt).find(key => {
          return models.includes(key) && partsConfig.bikeArt[key] === true;
        }) || models[0];

      const colors = data
        .filter(cust => cust.customizationType === 'color')
        .map(entry => entry.partId);
      let selectedColor =
        Object.keys(partsConfig.bikeArt).find(key => {
          return colors.includes(key) && partsConfig.bikeArt[key] === true;
        }) || colors[0];

      if (selectedAngle) {
        selectedModel = selectedAngleCust.configData.linkBack.model;
        selectedColor = selectedAngleCust.configData.linkBack.color;
      }

      const selectedModelCust = data.filter(
        part => part.partId === selectedModel
      )[0];

      const selectedColorCust = data.filter(
        part => part.partId === selectedColor
      )[0];

      if (!selectedColorCust.dependencies.parts.includes(selectedModel)) {
        selectedColor = data.filter(
          cust =>
            cust.customizationType === 'color' &&
            cust.dependencies.parts.includes(selectedModel)
        )[0].partId;
      }

      const numberPlates = allAvailableCustomizations.bikeArt.filter(cust =>
        cust.partId.match(/BN\d{4}[F|B]/i)
      );
      const bikeFrontTexts = allAvailableCustomizations.bikeArt.filter(cust =>
        cust.partId.match(/TXT\d{3}F/i)
      );

      const numberPlate = numberPlates.filter(plate =>
        plate.dependencies.parts.includes(selectedAngle)
      )[0];
      // bikeTextConfig.bikeText = bikeTexts.filter(text =>
      //   text.dependencies.parts.includes(selectedAngle)
      // )[0];

      const filteredData = data.filter(
        entry =>
          entry.customizationType === 'model' ||
          (currentActiveParent === 'back' &&
            entry.customizationType === 'placement') ||
          (entry.customizationType === 'color' &&
            entry.dependencies.parts.includes(selectedModel)) ||
          (entry.customizationType === 'angle' &&
            selectedModelCust.secondaryDependencies[selectedColor] &&
            selectedModelCust.secondaryDependencies[selectedColor].includes(
              entry.partId
            ))
      );
      if (numberPlate) filteredData.push(numberPlate);
      if (bikeFrontTexts.length > 0) filteredData.push(bikeFrontTexts[0]);
      return filteredData;
    }
    return data;
  };

  const sortAndGetTabIndex = tab => {
    switch (tab) {
      case 'model':
        return 0;
      case 'color':
        return 1;
      case 'angle':
        return 2;
      case 'placement':
        return 3;
      default:
        return null;
    }
  };

  // triggers when any category customiztions are mounted

  useEffect(() => {
    let hotspots = [];

    const customizations = availableCustomizations
      ? [...availableCustomizations.map(cust => cust.partId)]
      : [];

    if (selectedCategory === 'frontBadge' || selectedCategory === 'sleeve') {
      const code = selectedCategory === 'frontBadge' ? 'TL' : 'SL';
      customizations.forEach((cust, i) => {
        const partId =
          cust.length === 4
            ? `${code}${cust}`
            : cust.replace(cust.substring(0, 2), code);
        customizations.splice(i, 1, partId);
      });
    }

    if (
      window.ScapicSDK &&
      availableCustomizations &&
      selectedVariant === 'TShirt'
    ) {
      const isCategoryLoaded = window.ScapicSDK.ensurePartIdsLoaded(
        customizations
      );

      if (
        !isCategoryLoaded &&
        currentActiveParent &&
        currentActiveParent !== 'armour'
      ) {
        setIsLoading(true);
        window.ScapicSDK.loadPartIds(customizations).then(() => {
          setIsLoading(false);
        });
      }
    }

    // if hotspots are available for the category, show based on sleeve or front else remove them
    if (currentActiveParent === 'front' && selectedCategory === 'frontBadge') {
      hotspots = availableHotspots.filter(
        part =>
          !part.includes('S') &&
          !Object.keys(partsConfig.frontBadge)
            .filter(key => partsConfig.frontBadge[key] === true)
            .find(entry => entry.includes(part.substring(1, 3)))
      );
    } else if (selectedCategory === 'sleeve') {
      hotspots = availableHotspots.filter(
        part =>
          part.includes('S') &&
          !Object.keys(partsConfig.sleeve)
            .filter(key => partsConfig.sleeve[key] === true)
            .find(entry => entry.includes(part.substring(1, 3)))
      );
    } else {
      removePartConfig('hotspots');
      setHotspot(null);
    }
    if (hotspots.length > 0) {
      hotspots.forEach(hotspot => {
        updatePartsConfig(
          {
            partId: hotspot,
            dependencies: { parts: [], collisions: [] },
            collisions: { parts: [], collisions: [] }
          },
          'hotspots',
          hotspots
        );
      });
    } else {
      setHotspot(null);
      removePartConfig('hotspots');
    }

    if (selectedCategory !== 'helmetType' && partsConfig[selectedCategory]) {
      const categoryConfig = partsConfig[selectedCategory];
      const viewCode = currentActiveParent === 'front' ? 'F' : 'B';

      let selectedPartId = Object.keys(categoryConfig).find(
        key => categoryConfig[key] === true
      );

      const availableAngles = availableCustomizations
        ? availableCustomizations
            .filter(cat => cat.customizationType === 'angle')
            .map(key => key.partId)
        : [];

      if (selectedCategory === 'bikeArt') {
        selectedPartId = Object.keys(categoryConfig).find(
          key =>
            availableAngles.includes(key) &&
            key[key.length - 1] === viewCode &&
            categoryConfig[key] === true
        );
      }
      let data = options;
      let customizationTypes = [];

      if (selectedBaseColorPartId) {
        const filteredData = getFilteredData(options);
        const selectedPartIdIndex = filteredData.indexOf(
          options.filter(entry => entry.partId === selectedPartId)[0]
        );
        setInitialSelectedCustomizationIndex(selectedPartIdIndex);
        data = getFilteredData(options);
      } else if (
        currentCategory.filterType &&
        currentCategory.filterType !== 'none'
      ) {
        getFilteredDataForInterCategoryDependency(options).forEach(entry => {
          if (
            entry.customizationType &&
            entry.customizationType !== '' &&
            !customizationTypes.includes(entry.customizationType)
          ) {
            if (selectedCategory === 'bikeArt')
              customizationTypes =
                currentActiveParent === 'front'
                  ? ['model', 'color', 'angle']
                  : ['model', 'color', 'angle', 'placement'];
            else customizationTypes.push(entry.customizationType);
            // const index = sortAndGetTabIndex(entry.customizationType);
            // if(index) customizationTypes[index] = entry.customizationType;
            // else customizationTypes.push(entry.customizationType);
          }
        });

        setAvailableTabs(customizationTypes);
        setSelectedTab(customizationTypes[0]);
        data = getFilteredDataForInterCategoryDependency(options).filter(
          entry =>
            entry.customizationType === customizationTypes[0] ||
            entry.partId.match(/BN\d{4}[F|B]/i)
        );
      }

      setCategoryData(data);

      // select the first by default on sub categories as they have collisions with each other

      if (!selectedPartId && currentCategory.categoryType === 'subCategory') {
        if (currentCategory.filterType === 'dependency') {
          // customizationTypes.forEach(type => {
          // data = getFilteredDataForInterCategoryDependency(options).filter(
          //   entry =>
          //     (entry.customizationType === 'angle' &&
          //       entry.partId[entry.partId.length - 2] === viewCode) ||
          //     (type !== 'angle' && entry.customizationType === type)
          // );
          updatePartsConfig(
            data[0],
            selectedCategory,
            availableCustomizations
              .filter(
                entry =>
                  !entry.customizationType ||
                  entry.customizationType !== 'model' ||
                  (entry.customizationType === 'angle' &&
                    entry.partId[entry.partId.length - 1] !== viewCode)
              )
              .map(cust => cust.partId)
          );
          // });
        } else {
          const option = data[0];

          if (selectedCategory === 'frontBadge') {
            const partId =
              data[0].partId.length === 4
                ? `TL${data[0].partId}`
                : data[0].partId.replace(data[0].partId.substring(0, 2), 'TL');
            option.partId = partId;
          }
          updatePartsConfig(option);
        }
      }
    }
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      if (selectedCategory === 'frontBadge' || selectedCategory === 'sleeve') {
        // setOpenActionPanel(false);
      } else {
        setOpenActionPanel(true);
      }
    }
  }, [selectedCategory, currentActiveParent]);

  useEffect(() => {
    if (reapplyCustomization.shouldApply) {
      if (reapplyCustomization.oldCategory)
        setSelectedCategory(reapplyCustomization.oldCategory);

      alertWrapper(
        {
          isOpen: true,
          title: 'Selection Conflict',
          message:
            'Your selection has a conflict with an existing customization. Cancel or continue anyway to remove the existing customization.',
          agreeButtonText: 'Continue Anyway',
          isDisagreeAvailable: true,
          disagreeButtonText: 'Cancel',
          onAgree: () => {
            if (reapplyCustomization.newCategory)
              setSelectedCategory(reapplyCustomization.newCategory);
            updatePartsConfig(
              reapplyCustomization.selectedPart,
              reapplyCustomization.newCategory,
              reapplyCustomization.ignoredList
            );
          },
          onDisagree: () => {
            setIsLoading(false);
            setShouldReapplyCustomization({
              shouldApply: false,
              oldCategory: null,
              newCategory: null,
              ignoredList: null
            });
          }
        },
        openAlertDialog,
        true
      );
    }
  }, [reapplyCustomization.shouldApply]);

  const selectTab = tab => {
    setSelectedTab(tab);
    let customizations = getFilteredDataForInterCategoryDependency(
      options
    ).filter(
      entry =>
        entry.customizationType === tab ||
        entry.partId.match(/BN\d{4}[F|B]/i) ||
        entry.partId.match(/TXT\d{3}F/i)
    );

    if (tab === 'angle') {
      if (currentActiveParent === 'front') {
        customizations = customizations.filter(
          entry =>
            entry.partId.match(/BN\d{4}F/i) ||
            entry.partId.match(/BC\d{4}F/i) ||
            entry.partId.match(/TXT\d{3}F/i)
        );
      } else {
        customizations = customizations.filter(
          entry =>
            entry.partId.match(/BN\d{4}B/i) || entry.partId.match(/BC\d{4}B/i)
        );
      }
    }
    setCategoryData(customizations);
  };

  const models = availableCustomizations
    ? availableCustomizations
        .filter(cust => cust.customizationType === 'model')
        .map(entry => entry.partId)
    : [];
  const selectedModel = partsConfig.bikeArt
    ? Object.keys(partsConfig.bikeArt).find(
        key => models.includes(key) && partsConfig.bikeArt[key] === true
      )
    : null;

  const colors = availableCustomizations
    ? availableCustomizations
        .filter(cust => cust.customizationType === 'color')
        .map(entry => entry.partId)
    : [];

  const selectedColor = partsConfig.bikeArt
    ? Object.keys(partsConfig.bikeArt).find(
        key => colors.includes(key) && partsConfig.bikeArt[key] === true
      )
    : null;

  const angles = availableCustomizations
    ? availableCustomizations
        .filter(cust => cust.customizationType === 'angle')
        .map(entry => entry.partId)
    : [];

  const selectedFrontAngle = partsConfig.bikeArt
    ? Object.keys(partsConfig.bikeArt).find(
        key =>
          angles.includes(key) &&
          key[key.length - 1] === 'F' &&
          partsConfig.bikeArt[key] === true
      )
    : null;

  const selectedBackAngle = partsConfig.bikeArt
    ? Object.keys(partsConfig.bikeArt).find(
        key =>
          angles.includes(key) &&
          key[key.length - 1] === 'B' &&
          partsConfig.bikeArt[key] === true
      )
    : null;

  useEffect(() => {
    if (selectedCategory === 'bikeArt' && !reapplyCustomization.shouldApply) {
      const availablePlate = options.filter(option =>
        option.partId.match(/BN\d{4}[F|B]/i)
      )[0];
      const selectedBikeTextBack = options.filter(
        entry =>
          entry.customizationType === 'placement' &&
          partsConfig.bikeArt[entry.partId] === true
      )[0];
      const availableBikeTextBack = options.filter(
        entry => entry.customizationType === 'placement'
      )[0];
      let availableNumberPlate = availablePlate;

      if (currentActiveParent === 'front') {
        availableNumberPlate = availableCustomizations
          .filter(cust => cust.partId.match(/BN\d{4}F/i))
          .find(
            entry =>
              entry.partId[entry.partId.length - 1] === 'F' &&
              entry.dependencies.parts.includes(selectedFrontAngle)
          );
        if (availableNumberPlate)
          setFrontBikeNumberPlate(
            tShirtBikeFrontNumberPlate.text[0].line,
            availableNumberPlate.configData.uOffset,
            availableNumberPlate.configData.vOffset,
            availableNumberPlate.configData.fontSize,
            availableNumberPlate.configData.width
          );
      } else {
        availableNumberPlate = availableCustomizations
          .filter(cust => cust.partId.match(/BN\d{4}B/i))
          .find(
            entry =>
              entry.partId[entry.partId.length - 1] === 'B' &&
              entry.dependencies.parts.includes(selectedBackAngle)
          );
        if (availableNumberPlate)
          setBackBikeNumberPlate(
            tShirtBikeBackNumberPlate.text[0].line,
            availableNumberPlate.configData.uOffset,
            availableNumberPlate.configData.vOffset,
            availableNumberPlate.configData.fontSize,
            availableNumberPlate.configData.width
          );
      }
      if (availableNumberPlate)
        updatePartsConfig(
          availableNumberPlate,
          'bikeArt',
          availableCustomizations.map(cust => cust.partId)
        );
      if (
        !selectedBikeTextBack &&
        availableBikeTextBack &&
        currentActiveParent === 'back'
      )
        updatePartsConfig(
          availableBikeTextBack,
          'bikeArt',
          availableCustomizations
            .filter(
              cust =>
                cust.customizationType !== 'placement' ||
                !cust.customizationType
            )
            .map(entry => entry.partId)
        );
    }
  }, [selectedFrontAngle, selectedBackAngle, selectedModel, selectedColor]);

  const clearAllSide = () => {
    const currentActiveParentCategory = allCategories.filter(
      cat => cat.name === currentActiveParent
    )[0];

    currentActiveParentCategory.childCategories.forEach(cat => {
      removePartConfig(cat);
    });
    setSelectedCategory(currentActiveParent);
  };

  // useEffect(() => {}, [currentActiveParent, selectedCategory]);

  let CurrentCategory = categoryComponents[selectedCategory];

  return (
    <div
      className={`customiser-controller ${keyboardOpen &&
        'customiser-controller-kb'}`}
      style={{ pointerEvents: openActionPanel ? 'all' : 'none' }}
    >
      <div
        className="customiser-controller_wheeler"
        style={{ pointerEvents: 'all' }}
      >
        <WheelSelector
          currentActiveParent={currentActiveParent}
          selectedVariant={selectedVariant}
          allCustomizations={allAvailableCustomizations}
          shouldSelectCategory={reapplyCustomization.shouldApply}
          partsConfig={partsConfig}
          setCurrentActiveParent={setCurrentActiveParent}
          currentCategoryName={selectedCategory}
          openActionPanel={() => {
            setOpenActionPanel(true);
          }}
          allCategories={allCategories}
          availableCategories={availableCategories.filter(category => {
            if (category.categoryType === 'subCategory') {
              return false;
            }
            if (
              category.name === 'visor' &&
              allAvailableCustomizations[category.name].length <= 1
            ) {
              return false;
            }
            return true;
          })}
          setIsLoading={setIsLoading}
          setCurrentCategory={setSelectedCategory}
        />
      </div>
      {CurrentCategory && (
        <div
          className={`customiser-controller_action-panel ${keyboardOpen &&
            'customiser-controller_action-panel-kb'} 
              ${selectedCategory === 'bikeArt' && 'action-panel-bikeArt'}
              ${selectedCategory === 'baseShirtColor' &&
                'action-panel-baseShirtColor'}
              ${selectedCategory === 'frontPrint' && 'action-panel-frontPrint'}
              ${selectedCategory === 'frontBadge' && 'action-panel-frontBadge'}

            `}
          style={{
            opacity: openActionPanel ? 1 : 0,
            pointerEvents: openActionPanel ? 'all' : 'none'
          }}
        >
          <ActionPanel
            onCloseButtonClick={() => {
              setOpenActionPanel(false);
            }}
            openActionPanel={openActionPanel}
            isCloseButtonHidden={false}
            currentActiveParent={currentActiveParent}
            onClearAll={clearAllSide}
          >
            {currentCategory &&
              currentCategory.filterType &&
              currentCategory.filterType !== 'none' &&
              availableTabs.length > 1 && (
                <Tabs
                  columns={availableTabs.length}
                  selectedTab={selectedTab}
                  setSelectedTab={selectTab}
                  options={availableTabs}
                  isUnderlined={currentCategory.filterType === 'dependency'}
                />
              )}
            <CurrentCategory
              selectedTab={selectedTab}
              options={categoryData.filter(
                option => option.partId !== 'DCL017'
              )}
              setHotspot={setHotspot}
              activeHotspot={activeHotspot}
              setOpenActionPanel={setOpenActionPanel}
              currentActiveParent={currentActiveParent}
              selectedCategory={selectedCategory}
              tShirtBikeFrontNumberPlate={tShirtBikeFrontNumberPlate}
              tShirtBikeBackNumberPlate={tShirtBikeBackNumberPlate}
              setFrontBikeNumberPlate={setFrontBikeNumberPlate}
              setBackBikeNumberPlate={setBackBikeNumberPlate}
              tShirtBikeFrontText={tShirtBikeFrontText}
              tShirtBikeBackText={tShirtBikeBackText}
              setFrontBikeText={setFrontBikeText}
              setBackBikeText={setBackBikeText}
              selectedPart={
                partsConfig[selectedCategory]
                  ? Object.keys(partsConfig[selectedCategory]).find(
                      key => partsConfig[selectedCategory][key] === true
                    )
                  : ''
              }
              removePartConfig={removePartConfig}
              initialSelectedCustomizationIndex={
                initialSelectedCustomizationIndex
              }
              availableCustomizations={allAvailableCustomizations}
              allCategoryCustomizations={getFilteredDataForInterCategoryDependency(
                options
              )}
              allBikeArtData={availableCustomizations}
              selectedBaseColorPartId={selectedBaseColorPartId}
              selectedVisorPartId={selectedVisorPartId}
              currentText={currentText}
              setCurrentText={setCurrentText}
              setIsConfigSaved={setIsConfigSaved}
              goggleConfig={partsConfig.goggle}
              updatePartsConfig={updatePartsConfig}
              partsConfig={partsConfig}
              openAlertDialog={openAlertDialog}
              availableCategories={availableCategories}
            />
          </ActionPanel>
        </div>
      )}
    </div>
  );
};

Controller.propTypes = {
  allAvailableCustomizations: PropTypes.object,
  availableCustomizations: PropTypes.array,
  availableColors: PropTypes.array,
  setSelectedCategory: PropTypes.func,
  shouldShowSidePane: PropTypes.bool,
  setShouldShowSidePane: PropTypes.func,
  updatePartsConfig: PropTypes.func,
  selectedCategory: PropTypes.string,
  partsConfig: PropTypes.object,
  removePartConfig: PropTypes.func,
  availableCategories: PropTypes.array,
  setCurrentText: PropTypes.func,
  setIsConfigSaved: PropTypes.func,
  currentText: PropTypes.array,
  allCategories: PropTypes.array,
  reapplyCustomization: PropTypes.object
};

export default Controller;
